@let searchLabelId = "search-label";
<form
  id="search-area"
  class="search"
  role="search"
  (submit)="submitSearch(input.value())"
>
  <ng-content select="[prefix]"></ng-content>

  <div class="search__bar" [class.search__bar--disabled]="!canSearch()">
    <app-input
      #input
      class="search__input"
      [label]="_placeholder()"
      [labelId]="searchLabelId"
      [disabled]="!canSearch() || inLoadingState()"
      [type]="'search'"
      [hotkeyAction]="'focus'"
      [autofocus]="autofocus()"
      [ariaControls]="ariaControls()"
      (actionTriggered)="input.focus()"
      (changed)="startSearch($event)"
    />
    @let canTriggerSearch =
      canSearch() && !!input._value() && !inLoadingState();
    @if (showButton()) {
      <button
        btn
        class="search__button"
        [attr.aria-label]="'Search for ' + input._value()"
        [disabled]="!canTriggerSearch"
        [kind]="canTriggerSearch ? 'PRIMARY' : 'LIGHT-OUTLINE'"
        [icon]="inLoadingState() ? 'spinner' : 'search'"
        [type]="'submit'"
      ></button>
    }
  </div>

  <ng-content select="[suffix]"></ng-content>
</form>
